import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { SiscallApp } from './SiscallApp';
import { Provider } from 'react-redux';
import { store } from './store';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <SiscallApp />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);